import './InitialStepFormComponent.v2.scss';

import React, { useState } from 'react';
import { SECTION_TYPE } from '../constants';
import { useSections } from '../useSections';
import { PersonalData } from '../sections/PersonalData/PersonalData';
import { AccessData } from '../sections/AccessData/AccessData';
import { PrecontractualDocs } from '../sections/PrecontractualDocs/PrecontractualDocs';
import { EmailOTPValidation } from '../sections/EmailOTPValidation/EmailOTPValidation';
import { ONBOARDING_FLAG_WEB_NEW_REGISTER } from 'constants/featureFlagging';
import { useUserProfileInitialization } from './hooks/useUserProfileInitialization';
import { useLastSectionValidationAndRegister } from './hooks/useLastSectionValidationAndRegister';
import { useUpdateOnboardingTypeByPromotionalCode } from './hooks/useUpdateOnboardingTypeByPromotionalCode';
import { useResetSectionsAfterOnboardingTypeChange } from 'components/newAccountSteps/initialStep/InitialStepForm.v2/hooks/useResetSectionsAfterOnboardingTypeChange';
import { useGetDefaultProducts } from 'components/newAccountSteps/initialStep/InitialStepForm.v2/hooks/useGetDefaultProducts';

const { ACCESS_DATA, EMAIL_OTP_VALIDATION, PERSONAL_DATA, PRECONTRACTUAL_DOCS } = SECTION_TYPE;

export const InitialStepFormComponentV2 = ({
    flags,
    actions,
    focus,
    formActions,
    preLoaderActions,
    productsActions,
    promotionalCode,
    readyCaptchaToken,
    userProfile,
    userProfileForm,
    options,
    optionsActions,
    initialStateSections,
    renderTermsAndConditions,
}) => {
    const [isAdviseShown, setIsAdviseShown] = useState(false);

    useUserProfileInitialization({ userProfile, formActions });

    useUpdateOnboardingTypeByPromotionalCode({ promotionalCode, formActions });

    const {
        state,
        validatePersonalDataSection,
        validateAccessDataSection,
        validatePrecontractualDocsSection,
        validateOTPValidationSection,
        modifyPersonalDataSection,
        modifyPrecontractualDocsSection,
        modifyEmailOTPSection,
        modifyAccessDataSection,
        resetPrecontractualDocsSection,
        resetEmailOTPSection,
        resetAccessDataSection,
    } = useSections(initialStateSections);

    const { handleValidationAndRegister } = useLastSectionValidationAndRegister({
        flags,
        userProfile,
        userProfileForm,
        validateSection: validateAccessDataSection,
        actions,
        preLoaderActions,
        readyCaptchaToken,
    });

    useResetSectionsAfterOnboardingTypeChange({
        isPersonalDataCompleted: state[PERSONAL_DATA].isCollapsed && state[PERSONAL_DATA].isValidated,
        resetPrecontractualDocsSection,
        resetEmailOTPSection,
        resetAccessDataSection,
        modifyPrecontractualDocsSection,
        formActions,
        onboardingType: userProfile.onboardingType,
    });

    useGetDefaultProducts(userProfile, productsActions.getProducts);

    const isNewRegisterActive = flags.get(ONBOARDING_FLAG_WEB_NEW_REGISTER);
    const promoCode = promotionalCode?.get('promotionalCode')?.get('code');

    return (
        <div className="initial-step-form-content">
            <PersonalData
                actions={actions}
                focus={focus}
                formActions={formActions}
                isCollapsed={state[PERSONAL_DATA].isCollapsed}
                isValidated={state[PERSONAL_DATA].isValidated}
                isNewRegisterActive={isNewRegisterActive}
                options={options}
                optionsActions={optionsActions}
                promoCode={promoCode}
                userProfile={userProfile}
                userProfileForm={userProfileForm}
                handleModifySection={modifyPersonalDataSection}
                handleValidateSection={validatePersonalDataSection}
                handleAdviseShown={setIsAdviseShown}
            />
            {!isAdviseShown && (
                <>
                    <PrecontractualDocs
                        actions={actions}
                        formActions={formActions}
                        handleModifySection={modifyPrecontractualDocsSection}
                        handleValidateSection={validatePrecontractualDocsSection}
                        isPersonalDataCompleted={state[PERSONAL_DATA].isCollapsed && state[PERSONAL_DATA].isValidated}
                        isCollapsed={state[PRECONTRACTUAL_DOCS].isCollapsed}
                        isValidated={state[PRECONTRACTUAL_DOCS].isValidated}
                        preLoaderActions={preLoaderActions}
                        promotionalCode={promotionalCode}
                        readyCaptchaToken={readyCaptchaToken}
                        userProfile={userProfile}
                        userProfileForm={userProfileForm}
                    />
                    <EmailOTPValidation
                        formActions={formActions}
                        handleModifySection={modifyEmailOTPSection}
                        handleValidateSection={validateOTPValidationSection}
                        isCollapsed={state[EMAIL_OTP_VALIDATION].isCollapsed}
                        isValidated={state[EMAIL_OTP_VALIDATION].isValidated}
                        preLoaderActions={preLoaderActions}
                        promoCode={promoCode}
                        readyCaptchaToken={readyCaptchaToken}
                        userProfile={userProfile}
                        userProfileForm={userProfileForm}
                    />
                    <AccessData
                        formActions={formActions}
                        handleModifyID={modifyPersonalDataSection}
                        handleModifySection={modifyAccessDataSection}
                        handleValidateSection={handleValidationAndRegister}
                        isCollapsed={state[ACCESS_DATA].isCollapsed}
                        isValidated={state[ACCESS_DATA].isValidated}
                        promoCode={promoCode}
                        userProfile={userProfile}
                        userProfileForm={userProfileForm}
                        renderTermsAndConditions={renderTermsAndConditions}
                    />
                </>
            )}
        </div>
    );
};
